import React, {useState} from 'react';
import styles from "./VideoModal.scss";
import blockStyles from '@baseStyles/block.scss';
import Modal from "@components/base/Modal/Modal";
import YoutubeEmbed from "@components/widgets/YouTubeEmbed/YouTubeEmbed";
import WistiaEmbed from "@components/widgets/WistiaEmbed/WistiaEmbed";

// Modal with content
const VideoModal = ({data, platform = 'youtube', color = ''}) => {

	const [isModalOpen, setIsModalOpen] = useState(true);

	if (!isModalOpen) {
		return null;
	}

	return (
	  <Modal onClose={() => setIsModalOpen(false)}>
		  <Content
			data={data}
			color={color}
			platform={platform}
		  />
	  </Modal>
	)
}

// Content of the modal
const Content = ({data, platform, color = ''}) => {
	const {
		title,
		videoId,
		autoPlay,
		watchText
	} = data;

	if (!data) {
		return;
	}

	return (
	  <div className={styles.containerScroll}>
		  <div className={`${styles.container} ${color ? blockStyles[color] : ''}`}>
			  {/*Modal title*/}
			  {title &&
				<h3 dangerouslySetInnerHTML={{__html: title}}/>
			  }

			  {/*Video embed*/}
			  <div className={styles.videoHolder}>
				  {platform === 'wistia' ?
					<WistiaEmbed hashedId={videoId} embedOptions={{autoPlay: autoPlay}}/>
					:
					<>
						<YoutubeEmbed maxHeight="100%" embedId={videoId} autoPlay={autoPlay}/>

						<div className={'tcenter'}>
							<a
							  href={'https://youtu.be/' + videoId}
							  className={'color-white'}
							  target={'_blank'} rel={'nofollow noreferrer'}>
								{watchText}
							</a>
						</div>
					</>
				  }
			  </div>
		  </div>
	  </div>
	)
}

export default VideoModal;
